import createStatefulContext from './createStatefulContext';

const ModalContext = createStatefulContext();

export default ModalContext;
